angular.module("myApp").directive("dateRangeFilter", function dateRangeFilter() {
  return {
    restrict: "E",
    scope: {
      model: "=",
      dateFrom: "@",
      dateTo: "@",
      onChange: "&",
    },
    template: `
<div class="date-range-filter">

  <div class="date-range-inputs">
    <div class="h --nowrap --s0">
      <div class="h --nowrap --sx">
        <input type="text"
               class="form-control input-sm"
               ng-model="dateFromUi"
               is-open="_open_df"
               ng-focus="_open_df = true" 
               ng-change="onFromChanged()"
               uib-datepicker-popup="dd.MM.yyyy"
               datepicker-options="$root.datepickerOptions">

        <button type="button"
                class="btn btn-default btn-sm btn-clear"
                ng-click="clearFrom()"
                ng-if="dateFromUi">
          <span class="glyphicon glyphicon-remove"></span>
        </button>
      </div>


      <label>līdz</label>
      <div class="h --nowrap --sx">
        <input type="text"
               class="form-control input-sm"
               ng-model="dateToUi"
               is-open="_open_to"
               ng-focus="_open_to = true" 
               ng-change="onToChanged()"
               uib-datepicker-popup="dd.MM.yyyy"
               datepicker-options="$root.datepickerOptions">

        <button type="button"
                class="btn btn-default btn-sm btn-clear"
                ng-click="clearTo()"
                ng-if="dateToUi">
          <span class="glyphicon glyphicon-remove"></span>
        </button>
      </div>
    </div>
  </div>

  <div class="h --s1 date-range-presets">
    <button type="button" class="btn btn-link btn-xs"
                          ng-click="setPreset('this-month')">
      Šomēnes
    </button>

    <button type="button" class="btn btn-link btn-xs"
                          ng-click="setPreset('prev-month')">
      Iepriekšējais mēnesis
    </button>

    <button type="button" class="btn btn-link btn-xs"
                          ng-click="setPreset('next-month')">
      Nākamais mēnesis
    </button>

    <button type="button" class="btn btn-link btn-xs"
                          ng-click="setPreset('next-year')">
      Nākamais gads
    </button>
  </div>

</div>

    `,
    link(scope) {
      const monthRange = (year, month) => {
        return {
          from: new Date(year, month, 1),
          to: new Date(year, month + 1, 0),
        }
      }

      scope.setPreset = (preset) => {
        const now = new Date()

        let range

        if (preset === "this-month") {
          range = monthRange(now.getFullYear(), now.getMonth())
        } else if (preset === "prev-month") {
          range = monthRange(now.getFullYear(), now.getMonth() - 1)
        } else if (preset === "next-month") {
          range = monthRange(now.getFullYear(), now.getMonth() + 1)
        } else if (preset === "next-year") {
          range = {
            from: new Date(now.getFullYear() + 1, 0, 1),
            to: new Date(now.getFullYear() + 1, 11, 31),
          }
        }

        scope.dateFromUi = range.from
        scope.dateToUi = range.to
        scope.model[scope.dateFrom] = formatIso(range.from)
        scope.model[scope.dateTo] = formatIso(range.to)
        scope.onChange()
      }

      const formatIso = (d) => {
        return d ? moment(d).format("YYYY-MM-DD") : null
      }

      const parseIso = (d) => {
        if (d) {
          return moment(d).toDate()
        }
      }

      scope.onFromChanged = () => {
        scope.model[scope.dateFrom] = formatIso(scope.dateFromUi)
        scope.onChange()
      }
      scope.onToChanged = () => {
        scope.model[scope.dateTo] = formatIso(scope.dateToUi)
        scope.onChange()
      }

      scope.clearFrom = () => {
        scope.model[scope.dateFrom] = null
        scope.dateFromUi = null
        scope.onChange()
      }

      scope.clearTo = () => {
        scope.model[scope.dateTo] = null
        scope.dateToUi = null
        scope.onChange()
      }

      scope.clear = () => {
        scope.model[scope.dateFrom] = null
        scope.model[scope.dateTo] = null
        scope.dateFromUi = null
        scope.dateToUi = null
        scope.onChange()
      }

      // iekšā nāk vnk yyyy-mm-dd
      // bet inputs grib Date objektus
      // nemokām izsaucēju ar nepieciešamību glabāt Date, lieto stringus un viss
      scope.dateFromUi = parseIso(scope.model[scope.dateFrom])
      scope.dateToUi = parseIso(scope.model[scope.dateTo])
    },
  }
})
